import { capitalize } from 'lodash-es';

import { Filters } from 'features/Filters/types/Filters';
import { EntityActions } from 'utils/actions';
import {
  ENTITIES_PAGE_BULK_CONFIRMATION_DIALOG_BY_FILTER_ID,
  ENTITIES_PAGE_CONFIRMATION_DIALOG_ID,
} from 'utils/defaults';
import { emptyFilters, toFiltersSearchParams } from 'utils/searchParamsConverter';
import { LiveStatus } from 'utils/statuses';

interface ActionConfigBase {
  label: string;
  count: number;
  shouldDisplay: boolean;
}

interface ActionConfig extends ActionConfigBase {
  entityPhraser: string;
  capitalizedEntityPhraser: string;
}

interface GetActionConfigParams {
  action: EntityActions;
  status: LiveStatus;
  isBulk: boolean;
  totalElements: number;
  numberOfSelectedEntitiesInStatus: (status: LiveStatus) => number;
  bulkActions: EntityActions[];
}

interface GetConfirmDialogConfigParams {
  action: EntityActions;
  isBulk: boolean;
  filters: Filters;
  selectedIds: string[];
}

const buildActionConfig = (config: ActionConfigBase): ActionConfig => {
  const entityPhraser = config.count > 1 ? 'entities' : 'entity';

  return {
    ...config,
    entityPhraser,
    capitalizedEntityPhraser: capitalize(entityPhraser),
  };
};

export const getActionConfig = ({
  action,
  status,
  isBulk,
  totalElements,
  numberOfSelectedEntitiesInStatus,
  bulkActions,
}: GetActionConfigParams): ActionConfig => {
  const label = capitalize(action.toLowerCase());

  if (isBulk) {
    return buildActionConfig({
      label,
      count: totalElements,
      shouldDisplay: bulkActions.includes(action),
    });
  }

  const count = numberOfSelectedEntitiesInStatus(status);

  return buildActionConfig({
    label,
    count,
    shouldDisplay: count !== 0,
  });
};

export const getConfirmDialogConfig = ({
  action,
  isBulk,
  filters,
  selectedIds,
}: GetConfirmDialogConfigParams) => {
  const confirmDialogId = isBulk
    ? ENTITIES_PAGE_BULK_CONFIRMATION_DIALOG_BY_FILTER_ID + action
    : ENTITIES_PAGE_CONFIRMATION_DIALOG_ID + action;
  const confirmParams = isBulk
    ? toFiltersSearchParams(filters)
    : toFiltersSearchParams({ ...emptyFilters, spaceIds: selectedIds });

  return { confirmDialogId, confirmParams };
};
